<template>
    <b-container class="pl-0 pr-0">
        <b-col lg="12" class="no-gutters">
            <b-row v-if="!loading && (!nearTeam || nearTeam.length < 1)">
                <span  class="col-12 no-results pt-1 pb-3">
                        {{ $t('team.no_teams') }}
                </span>
            </b-row>
            <b-row>
                <div class="col-lg-3 col-md-3 col-sm-4 col-6 mb-3" v-for="(teamInfo) in visibleTeams" :key="teamInfo.team.id">
                    <div class="team-container align-top">
                        <div class="card team-logo-container" @click.stop="goToTeamInfo(teamInfo)">
                            <fair-image
                                :image-id="teamInfo.team.logo?teamInfo.team.logo.id:null"
                                class="team-img"
                                @onLoaded="addVisibleResults"
                            />
                            <!-- Hidden until locations are enabled!
                            <div class="team-header">
                                <font-awesome-icon icon="map-marker"/>
                                <span class="ml-2">
                                {{ teamInfo.team.organization.address.city }}
                            </span>
                            </div>
                            -->
                        </div>
                        <div class="team-info-container">
                            <span class="mb-0 mt-3 team-info-text">
                                <!-- {{getOrderNumber(index)}}. --> {{ teamInfo.team.name }}
                            </span>
                            <!--<div v-if="teamInfo.campaigns && teamInfo.campaigns.length > 0" class="note m-1 mb-0">
                                {{ $tc('organization.campaigns', teamInfo.campaigns.length) }}
                            </div>-->
                        </div>
                    </div>
                </div>
            </b-row>
            <div v-if="loading"
                 id="loader"
                 class="spinner">
            </div>
        </b-col>
    </b-container>
</template>

<script>
    import FairApi from "../../modules/api";
    import FairImage from "../FairImage";
    export default {
        name: "team-feed",
        components: {FairImage},
        data() {
            return {
                results: null,
                nearTeam: [],
                visibleTeams: [],
                loading: false
            }
        },
        props: {
            category: {
                type: Number,
                default: 0
            },
            limitBy: {
                type: Number,
                default: null
            },
            organizationId: {
                type: Number,
                default: null
            },
            fetchAll: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            category: function () {
                this.fetchNearbyTeams()
            },
            organizationId: function () {
                this.fetchNearbyTeams()
            }
        },

        mounted() {
            if (this.limitBy !== null || this.category > 0 || this.fetchAll || this.organizationId > 0) {
                this.fetchNearbyTeams()
            }
        },

        methods: {
            fetchNearbyTeams: function () {
                this.loading = true
                this.visibleTeams = []
                let param = {}
                if (this.category && this.category > 0) {
                    param = {'category': this.category}
                }
                FairApi.getWithParams(FairApi.teamNearby(), param,
                    this.success, this.failed)
            },

            success: function (response) {
                response = this.organizationId ? response.filter((item) => {
                    return item.team.organization.id === this.organizationId
                }) : response
                this.nearTeam = this.limitBy ? response.splice(0, this.limitBy) : response
                this.addVisibleResults()
                this.loading = false
            },

            failed: function () {
                this.loading = false
            },

            goToTeamInfo (team) {
                this.$router.push({name: 'team-info-view',
                    params: {teamInfo: team.team, id: team.team.id}})
            },

            scrollBack () {
                let offset = window.innerWidth*0.7;
                this.$refs.scroller.scrollLeft = this.$refs.scroller.scrollLeft-offset
            },

            scrollAhead () {
                let offset = window.innerWidth*0.7;
                this.$refs.scroller.scrollLeft = this.$refs.scroller.scrollLeft+offset
            },

            addVisibleResults() {
                if (this.visibleTeams.length < this.nearTeam.length) {
                    this.visibleTeams.push(this.nearTeam[this.visibleTeams.length])
                }
            },

            getOrderNumber(index) {
                index++;

                if (index < 10) {
                    index = `0${index}`
                }

                return index;
            }
        }
    }
</script>

<style scoped>
</style>
